import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import vigneshPhoto from '../../../../assets/images/Doctorsimages/vigneshdr.png'; 
import favicon from "../../../../assets/images/favicon.ico";
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const VigneshDoc = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Dr. R. Vignesh Kumar | Best Dermatologist & Clinical Director in Bangalore & Chennai | H-Cura";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. R. Vignesh Kumar (MBBS, DDVL), Clinical Director at H-Cura and a leading Dermatologist with 16+ years of experience. Expert in advanced cosmetology, lasers, and evidence-based skin treatments in Bangalore and Chennai."
      );
    }

    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "Best dermatologist in Bangalore, Clinical Director H-Cura, Top skin specialist in Chennai, Senior dermatologist Jayanagar, Dermatologist with 16 years experience, Advanced laser hair removal, Evidence-based skin treatment, Apollo clinic dermatologist, Manipal hospital skin specialist, international dermatologist Nigeria Congo"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-r-vignesh-kumar-clinical-director-dermatology";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }
  }, []);

   const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    
    // Add PDF-specific class to container
    container.classList.add('veenadoc-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    
    // Temporarily modify styles for PDF capture
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    // FIX: Ensure images are fully visible (This is missing in your current VigneshDoc code)
    const images = container.querySelectorAll('img');
    images.forEach(img => {
      img.style.opacity = '1';
    });

    // Wait a moment for styles to apply
    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: true, // Added to handle cross-origin images
        imageTimeout: 0,  // Prevents timeout if image takes time to render
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        
        // Restore original styles
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const availableWidth = pdfWidth - (marginLeft * 2);
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr_R_Vignesh_Kumar_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. R. Vignesh Kumar</span>
                 <span>

                 </span>
                  <span className="veenadoc-title-credentials">(MBBS, DDVL, Diploma in Cosmetology & Lasers)</span>
                 
                  <span className="veenadoc-title-location">Clinical Director & Senior Consultant Dermatologist</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A visionary doctor in Dermatology with over <strong>16 years</strong> of intensive clinical practice. 
                    As the Clinical Director at H-Cura,he is a strong support for medical excellence, , bridging the gap 
                    between traditional medical dermatology and cutting-edge aesthetic science across the company’s clinic branches in Chennai, Bengaluru, Coimbatore, Salem, Pondicherry, Guntur, and other locations.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={vigneshPhoto} alt="Dr. R. Vignesh Kumar - Clinical Director" className="veenadoc-doctor-image" title='Dr. R. Vignesh Kumar – Clinical Director & Senior Dermatologist' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              
              <div className="veenadoc-article-main">
                <div className="veenadoc-article-block">
                  <h2>About Dr. R. Vignesh Kumar</h2>
                  <p>
                    Dr. R. Vignesh Kumar is recognized as one of the most trusted names in dermatology and medical aesthetics. 
                    His dual role as a <strong>Dermatologist clinician</strong> and <strong>Clinical Director</strong> ensures that every treatment protocol at H-Cura 
                    meets the highest international standards of safety, ethics, and efficacy.
                  </p>
                  <p>
                    With nearly two decades of experience, he has established himself as a supporting doctor, mentoring medical professionals across all our clinical branches with a deep understanding of both medical and aesthetic outcomes.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Distinguished Educational Foundation</h2>
                  <p>
                    His expertise is built upon a foundation of rigorous academic training from India’s premier medical institutions. 
                    He earned his MBBS from <strong>Sri Devaraj Urs Medical College</strong> in Kolar, Karnataka, followed by a 
                    specialization in Dermatology (DDVL) at the prestigious <strong>Sri Ramachandra Medical College</strong> in Chennai.
                  </p>
                  <p>
                    Recognizing the future of skin health, he pursued a specialized <strong>Diploma in Cosmetology & Lasers </strong> 
                    from the Indian Institute of Cosmetology, Trichology & Nutrition in Bangalore, mastering high-precision 
                    medical-grade laser technologies.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">MBBS, DDVL</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">16+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Role:</span>
                      <span className="veenadoc-info-value">Clinical Director</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Aesthetics & Lasers</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Global & Institutional Legacy</h2>
                  <p>
                    Before leading H-Cura, Dr. Vignesh Kumar built a formidable reputation at world-class healthcare institutions. 
                    He served as a consultant at <strong>Manipal Hospital</strong> and <strong>Apollo Clinic</strong> in Bangalore. 
                  </p>
                  <p>
                    His clinical perspective is further enriched by extensive international tenure. He served as a lead specialist 
                    at the <strong>Fuvahmulah Government Hospital, Maldives</strong> and <strong>Hithadhoo Regional Government Hospital, Addu Atoll, Maldives</strong>.. Furthermore, his global expertise spans 
                    across Africa, where he practiced in <strong>Nigeria</strong> and <strong>Congo</strong>, managing diverse 
                    dermatological conditions and rare skin disorders in international clinical environments.
                  </p>
                  <p>
                    In the digital age, he has been a pioneer in tele-dermatology, serving as a senior consultant for 
                    <strong> Practo</strong> and <strong>Medibuddy</strong>, ensuring quality skin care reaches patients 
                    globally through evidence-based teleconsultation.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Specialized Clinical Expertise</h2>
                  <p>Under his leadership, H-Cura has become a center of excellence for several specialized treatments:</p>
                  <ul className="veenadoc-search-queries-list">
                    <li><strong>Advanced Medical Lasers:</strong> Precision hair reduction, tattoo removal, and scar resurfacing.</li>
                    <li><strong>Clinical Dermatology:</strong> Management of Psoriasis, Eczema, and complex skin infections.</li>
                    <li><strong>Aesthetic Transformation:</strong> Anti-aging fillers, skin tightening, and advanced chemical peels.</li>
                    <li><strong>Acne & Scar Management:</strong> Utilizing CO2 fractional lasers and subcision for smooth skin.</li>
                    <li><strong>Evidence-Based Cosmetology:</strong> Medically safe skin whitening and rejuvenation.</li>
                  </ul>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choosing Excellence in Skin Care</h2>
                  <p>
                    Choosing Dr. R. Vignesh Kumar means putting your health in the hands of  an experienced professional who 
                    values science as much as aesthetics. His patient-centric approach ensures you receive the highest 
                    level of care available in modern dermatology today.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>His Mission:</strong> To empower patients with healthier lives and renewed confidence through 
                    world-class, evidence-based  dermatological care.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Believes in Evidence Based Treatment, Implementing Advanced and Effective Cosmetology procedures at an affordable cost for patients."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Vignesh Kumar's Philosophy of Care</p>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Jayanagar, Bangalore</h4>
                      <p>H-Cura Multispeciality Clinic</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Chennai Branches</h4>
                      <p>Advanced Clinical Care</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Expert Consultation</h3>
                  <p>Consult with our Clinical Director for comprehensive skin and hair solutions.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    📞 Call +91 99646 88333
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow />

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Dr. Vignesh Kumar's Profile as PDF
        </button>
      </div>
    </>
  );
};

export default VigneshDoc;
